import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useNavigation } from "src/context/NavigationContext";

/**
 * Hook to set up mobile header with back navigation for settings pages.
 * Call this in each settings route to enable the mobile header with back button.
 *
 * @param title - The title to display in the mobile header
 */
export function useSettingsMobileHeader(title: string) {
  const navigate = useNavigate();
  const { isMobile, setMobileConversationHeader } = useNavigation();

  useEffect(() => {
    if (isMobile) {
      setMobileConversationHeader({
        title,
        onBack: () => navigate("/settings"),
      });
    } else {
      setMobileConversationHeader(null);
    }
    return () => setMobileConversationHeader(null);
  }, [isMobile, title, navigate, setMobileConversationHeader]);
}
